export default {"src":"/_next/static/media/discord.14e8954f.svg","height":20,"width":22};